const colors = {}

colors.componentToHex = (c) => {
  const hex = c.toString(16)
  return hex.length === 1 ? '0' + hex : hex
}

colors.rgbToHex = (r, g, b) => {
  return '#' + colors.componentToHex(r) + colors.componentToHex(g) + colors.componentToHex(b)
}

colors.hexToRgb = (hex) => {
  if (hex) {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
      return r + r + g + g + b + b
    })

    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null
  }
}

/**
 * Converts an RGB color value to HSV. Conversion formula
 * adapted from http://en.wikipedia.org/wiki/HSV_color_space.
 * Assumes r, g, and b are contained in the set [0, 255] and
 * returns h, s, and v in the set [0, 1].
 *
 * @param   Number  r       The red color value
 * @param   Number  g       The green color value
 * @param   Number  b       The blue color value
 * @return  Array           The HSV representation
 */
colors.rgbToHsv = (r, g, b) => {
  r /= 255
  g /= 255
  b /= 255

  var max = Math.max(r, g, b)
  var min = Math.min(r, g, b)
  var h = max
  var s = max
  var v = max

  var d = max - min
  s = max === 0 ? 0 : d / max

  if (max === min) {
    h = 0 // achromatic
  } else {
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0)
        break
      case g:
        h = (b - r) / d + 2
        break
      case b:
        h = (r - g) / d + 4
        break
    }

    h /= 6
  }

  return { h, s, v }
}

// function componentToHex (c) {
//   let hex = c.toString(16)
//   return hex.length === 1 ? '0' + hex : hex
// }
//
// function rgbToHex (r, g, b) {
//   return '#' + componentToHex(r) + componentToHex(g) + componentToHex(b)
// }
//
// function hexToRgb (hex) {
//   // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
//   let shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
//   hex = hex.replace(shorthandRegex, function (m, r, g, b) {
//     return r + r + g + g + b + b
//   })
//
//   let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
//   return result ? {
//     r: parseInt(result[1], 16),
//     g: parseInt(result[2], 16),
//     b: parseInt(result[3], 16)
//   } : null
// }
//
// /**
//  * Converts an RGB color value to HSV. Conversion formula
//  * adapted from http://en.wikipedia.org/wiki/HSV_color_space.
//  * Assumes r, g, and b are contained in the set [0, 255] and
//  * returns h, s, and v in the set [0, 1].
//  *
//  * @param   Number  r       The red color value
//  * @param   Number  g       The green color value
//  * @param   Number  b       The blue color value
//  * @return  Array           The HSV representation
//  */
// function rgbToHsv (r, g, b) {
//   r /= 255, g /= 255, b /= 255
//
//   var max = Math.max(r, g, b), min = Math.min(r, g, b)
//   var h, s, v = max
//
//   var d = max - min
//   s = max === 0 ? 0 : d / max
//
//   if (max === min) {
//     h = 0 // achromatic
//   } else {
//     switch (max) {
//       case r:
//         h = (g - b) / d + (g < b ? 6 : 0)
//         break
//       case g:
//         h = (b - r) / d + 2
//         break
//       case b:
//         h = (r - g) / d + 4
//         break
//     }
//
//     h /= 6
//   }
//
//   return {h, s, v}
// }

export default colors
